<script lang="ts">
  import { Col, Label } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import data from "../../../../Data/Ecommerce/Ecommerce.json"
  import { Brand } from "../../../../utils/Constant/Constant";
  import CollectionFilter from "./CollectionFilter.svelte";
</script>
<Col xl="2" md="6" class="box-col-6 xl-50 proorder-lg-1">
  <Card>
    <div slot="contentbody">
      <div class="filter-block">
        <h4>{Brand}</h4>
        <ul>
          {#each data.brandproductdata as brandItem }
            <li>
              <div class="form-check">
                <input class="form-check-input" id={brandItem} type="checkbox">
                <Label class="form-check-label" for={brandItem}>{brandItem}</Label>
              </div>
            </li>
          {/each}
        </ul>
      </div>
    </div>
  </Card>
  <CollectionFilter />
</Col>